// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see DeclinePreventionBlockerServerFlowInitEvent
 */
export var DeclinePreventionBlockerServerFlowInit = function (_a) {
    var flowToken = _a.flowToken, requestId = _a.requestId;
    return ({
        name: "DeclinePreventionBlocker ServerFlow Init",
        parameters: {
            cdf_entity: "DeclinePreventionBlocker",
            cdf_action: "ServerFlow",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            request_id: requestId !== undefined && requestId !== null ? requestId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see DeclinePreventionBlockerInteractConfirmClickedEvent
 */
export var DeclinePreventionBlockerInteractConfirmClicked = function (_a) {
    var flowToken = _a.flowToken, defaultAmount = _a.defaultAmount, selectedAmount = _a.selectedAmount;
    return ({
        name: "DeclinePreventionBlocker Interact ConfirmClicked",
        parameters: {
            cdf_entity: "DeclinePreventionBlocker",
            cdf_action: "Interact",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            default_amount: defaultAmount !== undefined && defaultAmount !== null ? defaultAmount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            selected_amount: selectedAmount !== undefined && selectedAmount !== null ? selectedAmount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see DeclinePreventionBlockerInteractPlusClickedEvent
 */
export var DeclinePreventionBlockerInteractPlusClicked = function (_a) {
    var flowToken = _a.flowToken;
    return ({
        name: "DeclinePreventionBlocker Interact PlusClicked",
        parameters: {
            cdf_entity: "DeclinePreventionBlocker",
            cdf_action: "Interact",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see DeclinePreventionBlockerInteractMinusClickedEvent
 */
export var DeclinePreventionBlockerInteractMinusClicked = function (_a) {
    var flowToken = _a.flowToken;
    return ({
        name: "DeclinePreventionBlocker Interact MinusClicked",
        parameters: {
            cdf_entity: "DeclinePreventionBlocker",
            cdf_action: "Interact",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see DeclinePreventionBlockerInteractInfoClickedEvent
 */
export var DeclinePreventionBlockerInteractInfoClicked = function (_a) {
    var flowToken = _a.flowToken;
    return ({
        name: "DeclinePreventionBlocker Interact InfoClicked",
        parameters: {
            cdf_entity: "DeclinePreventionBlocker",
            cdf_action: "Interact",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
